// Massive shared quiz data pools to give >1000 unique question variations across games.
// Each pool is curated kid-friendly and Indonesian.

// 50+ Animals with TTS-friendly sounds
export const ANIMALS = [
  { name: "Kucing", emoji: "🐱", sound: "Meong meong" },
  { name: "Anjing", emoji: "🐶", sound: "Guk guk guk" },
  { name: "Sapi", emoji: "🐮", sound: "Mooo" },
  { name: "Ayam", emoji: "🐔", sound: "Petok petok" },
  { name: "Bebek", emoji: "🦆", sound: "Kwek kwek" },
  { name: "Domba", emoji: "🐑", sound: "Mbeeek" },
  { name: "Babi", emoji: "🐷", sound: "Oink oink" },
  { name: "Singa", emoji: "🦁", sound: "Auuuummm" },
  { name: "Gajah", emoji: "🐘", sound: "Treeeeet" },
  { name: "Monyet", emoji: "🐵", sound: "U a u a" },
  { name: "Kuda", emoji: "🐴", sound: "Hiiii hiii" },
  { name: "Burung", emoji: "🐦", sound: "Cuit cuit" },
  { name: "Kambing", emoji: "🐐", sound: "Mbeeek mbeeek" },
  { name: "Tikus", emoji: "🐭", sound: "Cit cit cit" },
  { name: "Kelinci", emoji: "🐰", sound: "Beuk beuk" },
  { name: "Rubah", emoji: "🦊", sound: "Auuu" },
  { name: "Beruang", emoji: "🐻", sound: "Grrrr" },
  { name: "Panda", emoji: "🐼", sound: "Grrr lembut" },
  { name: "Harimau", emoji: "🐯", sound: "Auuuummm" },
  { name: "Serigala", emoji: "🐺", sound: "Auuuuwwwwooo" },
  { name: "Kuda Nil", emoji: "🦛", sound: "Hooooonk" },
  { name: "Badak", emoji: "🦏", sound: "Grunt grunt" },
  { name: "Jerapah", emoji: "🦒", sound: "Hum hum" },
  { name: "Zebra", emoji: "🦓", sound: "Hi hi hi" },
  { name: "Kanguru", emoji: "🦘", sound: "Tap tap" },
  { name: "Koala", emoji: "🐨", sound: "Bellow lembut" },
  { name: "Penguin", emoji: "🐧", sound: "Aak aak" },
  { name: "Bebek", emoji: "🦆", sound: "Kwek kwek" },
  { name: "Angsa", emoji: "🦢", sound: "Honk honk" },
  { name: "Merak", emoji: "🦚", sound: "Mey mey" },
  { name: "Burung Hantu", emoji: "🦉", sound: "Huuu huuu" },
  { name: "Elang", emoji: "🦅", sound: "Cieeeet" },
  { name: "Ikan", emoji: "🐟", sound: "Bloop bloop" },
  { name: "Hiu", emoji: "🦈", sound: "Suuusss" },
  { name: "Lumba-lumba", emoji: "🐬", sound: "Tik tik tik" },
  { name: "Paus", emoji: "🐋", sound: "Wuuuuooo" },
  { name: "Gurita", emoji: "🐙", sound: "Diam" },
  { name: "Kepiting", emoji: "🦀", sound: "Klek klek" },
  { name: "Udang", emoji: "🦐", sound: "Diam" },
  { name: "Kura-kura", emoji: "🐢", sound: "Diam" },
  { name: "Kodok", emoji: "🐸", sound: "Koak koak" },
  { name: "Ular", emoji: "🐍", sound: "Ssssss" },
  { name: "Buaya", emoji: "🐊", sound: "Hisss" },
  { name: "Cicak", emoji: "🦎", sound: "Ck ck ck" },
  { name: "Laba-laba", emoji: "🕷️", sound: "Diam" },
  { name: "Kupu-kupu", emoji: "🦋", sound: "Diam" },
  { name: "Lebah", emoji: "🐝", sound: "Zzzzz" },
  { name: "Semut", emoji: "🐜", sound: "Diam" },
  { name: "Kunang-kunang", emoji: "✨", sound: "Diam" },
  { name: "Capung", emoji: "🐉", sound: "Zzzz lembut" },
];

// 30+ Colors
export const COLORS = [
  { id: "merah", name: "Merah", hex: "#EF4444" },
  { id: "biru", name: "Biru", hex: "#3B82F6" },
  { id: "hijau", name: "Hijau", hex: "#22C55E" },
  { id: "kuning", name: "Kuning", hex: "#FACC15" },
  { id: "ungu", name: "Ungu", hex: "#A855F7" },
  { id: "oranye", name: "Oranye", hex: "#F97316" },
  { id: "merahmuda", name: "Merah Muda", hex: "#EC4899" },
  { id: "coklat", name: "Coklat", hex: "#92400E" },
  { id: "hitam", name: "Hitam", hex: "#1F2937" },
  { id: "putih", name: "Putih", hex: "#F8FAFC" },
  { id: "biru_muda", name: "Biru Muda", hex: "#67E8F9" },
  { id: "biru_tua", name: "Biru Tua", hex: "#1E3A8A" },
  { id: "hijau_muda", name: "Hijau Muda", hex: "#86EFAC" },
  { id: "hijau_tua", name: "Hijau Tua", hex: "#14532D" },
  { id: "merah_muda", name: "Pink Lembut", hex: "#FBCFE8" },
  { id: "ungu_muda", name: "Lavender", hex: "#DDD6FE" },
  { id: "abu", name: "Abu-abu", hex: "#9CA3AF" },
  { id: "krem", name: "Krem", hex: "#FEF3C7" },
  { id: "emas", name: "Emas", hex: "#FFD700" },
  { id: "perak", name: "Perak", hex: "#C0C0C0" },
  { id: "tosca", name: "Tosca", hex: "#14B8A6" },
  { id: "magenta", name: "Magenta", hex: "#D946EF" },
  { id: "limau", name: "Hijau Limau", hex: "#84CC16" },
  { id: "kuning_lembut", name: "Kuning Lembut", hex: "#FEF08A" },
  { id: "oranye_muda", name: "Oranye Muda", hex: "#FDBA74" },
  { id: "merah_tua", name: "Merah Tua", hex: "#991B1B" },
  { id: "coklat_muda", name: "Coklat Muda", hex: "#D2B48C" },
  { id: "navy", name: "Biru Navy", hex: "#1E3A8A" },
  { id: "merun", name: "Maroon", hex: "#7F1D1D" },
  { id: "salmon", name: "Salmon", hex: "#FCA5A5" },
  { id: "indigo", name: "Indigo", hex: "#4F46E5" },
  { id: "olive", name: "Olive", hex: "#65A30D" },
];

// 60+ Country flags
export const FLAGS = [
  { country: "Indonesia", flag: "🇮🇩" },
  { country: "Malaysia", flag: "🇲🇾" },
  { country: "Singapura", flag: "🇸🇬" },
  { country: "Thailand", flag: "🇹🇭" },
  { country: "Filipina", flag: "🇵🇭" },
  { country: "Vietnam", flag: "🇻🇳" },
  { country: "Jepang", flag: "🇯🇵" },
  { country: "Korea Selatan", flag: "🇰🇷" },
  { country: "Tiongkok", flag: "🇨🇳" },
  { country: "India", flag: "🇮🇳" },
  { country: "Amerika", flag: "🇺🇸" },
  { country: "Inggris", flag: "🇬🇧" },
  { country: "Prancis", flag: "🇫🇷" },
  { country: "Jerman", flag: "🇩🇪" },
  { country: "Italia", flag: "🇮🇹" },
  { country: "Spanyol", flag: "🇪🇸" },
  { country: "Brazil", flag: "🇧🇷" },
  { country: "Australia", flag: "🇦🇺" },
  { country: "Kanada", flag: "🇨🇦" },
  { country: "Mesir", flag: "🇪🇬" },
  { country: "Arab Saudi", flag: "🇸🇦" },
  { country: "Turki", flag: "🇹🇷" },
  { country: "Belanda", flag: "🇳🇱" },
  { country: "Swiss", flag: "🇨🇭" },
  { country: "Swedia", flag: "🇸🇪" },
  { country: "Norwegia", flag: "🇳🇴" },
  { country: "Denmark", flag: "🇩🇰" },
  { country: "Finlandia", flag: "🇫🇮" },
  { country: "Belgia", flag: "🇧🇪" },
  { country: "Austria", flag: "🇦🇹" },
  { country: "Portugal", flag: "🇵🇹" },
  { country: "Yunani", flag: "🇬🇷" },
  { country: "Rusia", flag: "🇷🇺" },
  { country: "Ukraina", flag: "🇺🇦" },
  { country: "Polandia", flag: "🇵🇱" },
  { country: "Argentina", flag: "🇦🇷" },
  { country: "Meksiko", flag: "🇲🇽" },
  { country: "Chile", flag: "🇨🇱" },
  { country: "Kolombia", flag: "🇨🇴" },
  { country: "Peru", flag: "🇵🇪" },
  { country: "Selandia Baru", flag: "🇳🇿" },
  { country: "Afrika Selatan", flag: "🇿🇦" },
  { country: "Nigeria", flag: "🇳🇬" },
  { country: "Kenya", flag: "🇰🇪" },
  { country: "Maroko", flag: "🇲🇦" },
  { country: "Iran", flag: "🇮🇷" },
  { country: "Israel", flag: "🇮🇱" },
  { country: "Qatar", flag: "🇶🇦" },
  { country: "UEA", flag: "🇦🇪" },
  { country: "Pakistan", flag: "🇵🇰" },
  { country: "Bangladesh", flag: "🇧🇩" },
  { country: "Sri Lanka", flag: "🇱🇰" },
  { country: "Nepal", flag: "🇳🇵" },
  { country: "Myanmar", flag: "🇲🇲" },
  { country: "Kamboja", flag: "🇰🇭" },
  { country: "Laos", flag: "🇱🇦" },
  { country: "Brunei", flag: "🇧🇳" },
  { country: "Timor Leste", flag: "🇹🇱" },
  { country: "Mongolia", flag: "🇲🇳" },
  { country: "Korea Utara", flag: "🇰🇵" },
  { country: "Taiwan", flag: "🇹🇼" },
  { country: "Hong Kong", flag: "🇭🇰" },
];

// TebakGambar massive item catalog (visuals via emoji), 80+ items × 6 categories
export const TEBAK_CATEGORIES = {
  hewan: { name: "Hewan", items: [
    { emoji: "🐱", name: "Kucing" }, { emoji: "🐶", name: "Anjing" }, { emoji: "🐘", name: "Gajah" },
    { emoji: "🦁", name: "Singa" }, { emoji: "🐸", name: "Kodok" }, { emoji: "🦋", name: "Kupu-kupu" },
    { emoji: "🐢", name: "Kura-kura" }, { emoji: "🐰", name: "Kelinci" }, { emoji: "🐼", name: "Panda" },
    { emoji: "🦊", name: "Rubah" }, { emoji: "🐮", name: "Sapi" }, { emoji: "🐔", name: "Ayam" },
    { emoji: "🦆", name: "Bebek" }, { emoji: "🐑", name: "Domba" }, { emoji: "🐷", name: "Babi" },
    { emoji: "🐵", name: "Monyet" }, { emoji: "🐴", name: "Kuda" }, { emoji: "🐯", name: "Harimau" },
    { emoji: "🐺", name: "Serigala" }, { emoji: "🦒", name: "Jerapah" }, { emoji: "🦓", name: "Zebra" },
    { emoji: "🦘", name: "Kanguru" }, { emoji: "🐨", name: "Koala" }, { emoji: "🐧", name: "Penguin" },
    { emoji: "🦉", name: "Burung Hantu" }, { emoji: "🦅", name: "Elang" }, { emoji: "🐍", name: "Ular" },
    { emoji: "🐊", name: "Buaya" }, { emoji: "🦎", name: "Cicak" }, { emoji: "🦂", name: "Kalajengking" },
    { emoji: "🦀", name: "Kepiting" }, { emoji: "🦐", name: "Udang" }, { emoji: "🐠", name: "Ikan" },
    { emoji: "🐋", name: "Paus" }, { emoji: "🦈", name: "Hiu" }, { emoji: "🐬", name: "Lumba-lumba" },
    { emoji: "🐝", name: "Lebah" }, { emoji: "🐜", name: "Semut" }, { emoji: "🕷️", name: "Laba-laba" },
    { emoji: "🐢", name: "Penyu" },
  ]},
  buah: { name: "Buah", items: [
    { emoji: "🍎", name: "Apel" }, { emoji: "🍌", name: "Pisang" }, { emoji: "🍊", name: "Jeruk" },
    { emoji: "🍇", name: "Anggur" }, { emoji: "🍓", name: "Stroberi" }, { emoji: "🍉", name: "Semangka" },
    { emoji: "🥭", name: "Mangga" }, { emoji: "🍍", name: "Nanas" }, { emoji: "🍑", name: "Persik" },
    { emoji: "🫐", name: "Bluberi" }, { emoji: "🍐", name: "Pir" }, { emoji: "🍒", name: "Ceri" },
    { emoji: "🍋", name: "Lemon" }, { emoji: "🥝", name: "Kiwi" }, { emoji: "🥥", name: "Kelapa" },
    { emoji: "🍅", name: "Tomat" }, { emoji: "🥑", name: "Alpukat" }, { emoji: "🍈", name: "Melon" },
    { emoji: "🍏", name: "Apel Hijau" }, { emoji: "🍆", name: "Terong" },
  ]},
  kendaraan: { name: "Kendaraan", items: [
    { emoji: "🚗", name: "Mobil" }, { emoji: "🚌", name: "Bus" }, { emoji: "✈️", name: "Pesawat" },
    { emoji: "🚢", name: "Kapal" }, { emoji: "🚲", name: "Sepeda" }, { emoji: "🚀", name: "Roket" },
    { emoji: "🚁", name: "Helikopter" }, { emoji: "🚂", name: "Kereta" }, { emoji: "🚕", name: "Taksi" },
    { emoji: "🏍️", name: "Motor" }, { emoji: "🚚", name: "Truk" }, { emoji: "🚜", name: "Traktor" },
    { emoji: "🚓", name: "Mobil Polisi" }, { emoji: "🚒", name: "Mobil Pemadam" }, { emoji: "🚑", name: "Ambulan" },
    { emoji: "⛵", name: "Perahu Layar" }, { emoji: "🛵", name: "Skuter" }, { emoji: "🛻", name: "Pickup" },
    { emoji: "🚆", name: "Kereta Cepat" }, { emoji: "🛺", name: "Bajaj" },
  ]},
  bentuk: { name: "Bentuk", items: [
    { emoji: "⭕", name: "Lingkaran" }, { emoji: "🔲", name: "Persegi" }, { emoji: "🔺", name: "Segitiga" },
    { emoji: "⭐", name: "Bintang" }, { emoji: "❤️", name: "Hati" }, { emoji: "🔷", name: "Belah Ketupat" },
    { emoji: "🔶", name: "Oranye" }, { emoji: "⬛", name: "Hitam" }, { emoji: "⬜", name: "Putih" },
    { emoji: "🟥", name: "Merah" }, { emoji: "🟦", name: "Biru" }, { emoji: "🟩", name: "Hijau" },
    { emoji: "🟨", name: "Kuning" }, { emoji: "🟧", name: "Oranye" }, { emoji: "🟪", name: "Ungu" },
    { emoji: "🔵", name: "Biru Bulat" }, { emoji: "🟢", name: "Hijau Bulat" }, { emoji: "🔴", name: "Merah Bulat" },
    { emoji: "🟡", name: "Kuning Bulat" }, { emoji: "🟣", name: "Ungu Bulat" },
  ]},
  makanan: { name: "Makanan", items: [
    { emoji: "🍔", name: "Burger" }, { emoji: "🍕", name: "Pizza" }, { emoji: "🍝", name: "Spageti" },
    { emoji: "🍜", name: "Mi" }, { emoji: "🍙", name: "Onigiri" }, { emoji: "🍣", name: "Sushi" },
    { emoji: "🌭", name: "Hot Dog" }, { emoji: "🌮", name: "Taco" }, { emoji: "🥗", name: "Salad" },
    { emoji: "🍳", name: "Telur" }, { emoji: "🍞", name: "Roti" }, { emoji: "🧀", name: "Keju" },
    { emoji: "🥞", name: "Pancake" }, { emoji: "🍰", name: "Kue" }, { emoji: "🍪", name: "Kue Kering" },
    { emoji: "🍦", name: "Es Krim" }, { emoji: "🍩", name: "Donat" }, { emoji: "🍫", name: "Cokelat" },
    { emoji: "🍿", name: "Popcorn" }, { emoji: "🥨", name: "Pretzel" },
  ]},
  benda: { name: "Benda", items: [
    { emoji: "📚", name: "Buku" }, { emoji: "✏️", name: "Pensil" }, { emoji: "📱", name: "HP" },
    { emoji: "💻", name: "Laptop" }, { emoji: "📷", name: "Kamera" }, { emoji: "⏰", name: "Jam Weker" },
    { emoji: "👓", name: "Kacamata" }, { emoji: "🎒", name: "Tas" }, { emoji: "🎈", name: "Balon" },
    { emoji: "🎁", name: "Hadiah" }, { emoji: "🔑", name: "Kunci" }, { emoji: "💡", name: "Lampu" },
    { emoji: "✂️", name: "Gunting" }, { emoji: "🧸", name: "Boneka" }, { emoji: "🏀", name: "Bola Basket" },
    { emoji: "⚽", name: "Bola Sepak" }, { emoji: "🎲", name: "Dadu" }, { emoji: "🪁", name: "Layangan" },
    { emoji: "🛹", name: "Skateboard" }, { emoji: "🎸", name: "Gitar" },
  ]},
};

// Many letter-word combos for huruf game (multiple words per letter for variety)
export const LETTER_WORDS = {
  A: [{w:"Apel",e:"🍎"},{w:"Anjing",e:"🐶"},{w:"Ayam",e:"🐔"},{w:"Awan",e:"☁️"},{w:"Api",e:"🔥"}],
  B: [{w:"Bola",e:"⚽"},{w:"Buku",e:"📚"},{w:"Bulan",e:"🌙"},{w:"Bunga",e:"🌸"},{w:"Bebek",e:"🦆"}],
  C: [{w:"Cabe",e:"🌶️"},{w:"Cicak",e:"🦎"},{w:"Coklat",e:"🍫"},{w:"Cermin",e:"🪞"}],
  D: [{w:"Domba",e:"🐑"},{w:"Donat",e:"🍩"},{w:"Daun",e:"🍃"},{w:"Durian",e:"🍈"}],
  E: [{w:"Es",e:"🍦"},{w:"Elang",e:"🦅"},{w:"Emas",e:"🥇"}],
  F: [{w:"Fitri",e:"🌷"},{w:"Foto",e:"📷"},{w:"Film",e:"🎬"}],
  G: [{w:"Gajah",e:"🐘"},{w:"Gunung",e:"⛰️"},{w:"Gitar",e:"🎸"},{w:"Garam",e:"🧂"}],
  H: [{w:"Hati",e:"❤️"},{w:"Hujan",e:"🌧️"},{w:"Helm",e:"⛑️"},{w:"Harimau",e:"🐯"}],
  I: [{w:"Ikan",e:"🐟"},{w:"Itik",e:"🦆"},{w:"Istana",e:"🏰"}],
  J: [{w:"Jeruk",e:"🍊"},{w:"Jam",e:"⏰"},{w:"Jagung",e:"🌽"},{w:"Jerapah",e:"🦒"}],
  K: [{w:"Kucing",e:"🐱"},{w:"Kunci",e:"🔑"},{w:"Kapal",e:"🚢"},{w:"Kelapa",e:"🥥"}],
  L: [{w:"Lemon",e:"🍋"},{w:"Lampu",e:"💡"},{w:"Lebah",e:"🐝"}],
  M: [{w:"Mangga",e:"🥭"},{w:"Mobil",e:"🚗"},{w:"Matahari",e:"☀️"},{w:"Monyet",e:"🐵"}],
  N: [{w:"Nanas",e:"🍍"},{w:"Naga",e:"🐉"},{w:"Nasi",e:"🍚"}],
  O: [{w:"Obat",e:"💊"},{w:"Otak",e:"🧠"},{w:"Orang Utan",e:"🦧"}],
  P: [{w:"Pisang",e:"🍌"},{w:"Pesawat",e:"✈️"},{w:"Pizza",e:"🍕"},{w:"Payung",e:"☂️"}],
  Q: [{w:"Quran",e:"📖"}],
  R: [{w:"Rumah",e:"🏠"},{w:"Roti",e:"🍞"},{w:"Roket",e:"🚀"},{w:"Rusa",e:"🦌"}],
  S: [{w:"Sapi",e:"🐮"},{w:"Sepatu",e:"👟"},{w:"Sekolah",e:"🏫"},{w:"Singa",e:"🦁"}],
  T: [{w:"Telur",e:"🥚"},{w:"Topi",e:"🎩"},{w:"Tas",e:"🎒"},{w:"Tomat",e:"🍅"}],
  U: [{w:"Ular",e:"🐍"},{w:"Udang",e:"🦐"},{w:"Uang",e:"💰"}],
  V: [{w:"Vas",e:"🏺"},{w:"Vampir",e:"🧛"}],
  W: [{w:"Wortel",e:"🥕"},{w:"Wayang",e:"🎭"}],
  X: [{w:"Xilofon",e:"🎼"}],
  Y: [{w:"Yoyo",e:"🪀"},{w:"Yogurt",e:"🍦"}],
  Z: [{w:"Zebra",e:"🦓"},{w:"Zaitun",e:"🫒"}],
};

// 30 pattern question generators (more variety = >1000 combos via random)
export const PATTERN_TYPES = [
  "add_small", "add_medium", "double", "triple", "subtract_small", "subtract_medium",
  "alternate", "skip_count_2", "skip_count_3", "skip_count_5", "fibonacci_easy", "halve",
];

// Day & month already finite (7+12), but we provide MULTI question types:
// - "what is day X" -> name
// - "what is month X" -> name
// - which day after Y?  - which month before Y?
export const DAY_MONTH_TYPES = ["day_index", "month_index", "day_after", "day_before", "month_after", "month_before"];
